/**
 *
 * ParrotSoftware
 * SettingsTablesConfigProvider constants
 *
 */
export const UPDATE_TABLE_CONFIG = 'providers/settings/TablesConfig/UPDATE_TABLE_CONFIG';
export const GET_STORE_TABLE_SETTINGS = 'providers/settings/TablesConfig/GET_STORE_TABLE_SETTINGS';
